<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加定位设备类型"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="positioningDeviceType" :rules="rules">
      <FormItem prop="name">
        <label>定位设备型号：</label>
        <Input v-model="positioningDeviceType.name" placeholder="请输入定位设备型号">
        </Input>
      </FormItem>
      <FormItem prop="manufacturername">
        <label>定位设备生产商型号：</label>
        <Input v-model="positioningDeviceType.manufacturername" placeholder="请输入定位设备生产商型号">
        </Input>
      </FormItem>
      <FormItem prop="manufacturer">
        <label>设备生产商：</label>
        <Input v-model="positioningDeviceType.manufacturer" placeholder="请输入生产商">
        </Input>
      </FormItem>
      <FormItem prop="parameter">
        <label>费用模式：</label>
        <Input v-model="positioningDeviceType.isfree" placeholder="请输入设备参数">
        </Input>
        <Select v-model="positioningDeviceType.isfree" style="width:200px">
          <Option v-for="item in freeType" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="remark">
        <label>设备备注：</label>
        <Input type="textarea" v-model="positioningDeviceType.remark" placeholder="请输入备注">
        </Input>
      </FormItem>
      <FormItem prop="remark">
<!--        <label>是否ADAS：</label>-->
        <Checkbox v-model="positioningDeviceType.adas"><span>是否ADAS</span></Checkbox>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'addpositioningdevicetypemodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    name: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '定位设备型号不能为空', trigger: 'blur' }
        ]
      }
    },
    manufacturername: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '定位设备生产商型号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      // positioningDeviceInfoStateOptions: [
      //   { label: '未安装', value: 1 },
      //   { label: '已安装', value: 2 },
      //   { label: '损坏', value: 3 }
      // ],
      // positioningDeviceModelOptions: [
      //   { label: 'BSJ-A6-BD', value: 1 },
      //   { label: 'BSJ-GF03', value: 2 },
      //   { label: 'BSJ-M11', value: 3 },
      //   { label: 'BSJ-A6L', value: 13 },
      //   { label: 'BSJ-A7', value: 14 },
      //   { label: 'K5', value: 4 },
      //   { label: 'D5X', value: 5 },
      //   { label: 'G-3G', value: 6 },
      //   { label: 'D5X-HDD', value: 7 },
      //   { label: 'D5X-XR', value: 8 },
      //   { label: 'BSJ-GF06', value: 9 },
      //   { label: 'BSJ-RM01', value: 10 },
      //   { label: 'HIK-A3', value: 11 },
      //   { label: 'HIK-A3L', value: 12 }
      // ],
      // positioningDeviceSourceTypeOptions: [
      //   { label: '新装', value: 1 },
      //   { label: '接入', value: 2 }
      // ],

      freeType:[
        {label:'自费模式',value:1},
        {label:'普通免费模式',value:2},
        {label:'太好保免费模式',value:3},
      ],

      positioningDeviceType: {
        name: null,
        manufacturername: null,
        parameter: null,
        manufacturer: null,
        isfree: null,
        remark: null,
        adas: false
      }
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceTypeServ_AddObj'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '添加定位设备类型',
        content: '<p>是否确认添加定位设备类型</p>',
        onOk: () => {
          store.dispatch('PositioningDeviceTypeServ_AddObj', { params: this.positioningDeviceType }).then(() => {
            this.$Message.success('添加定位设备类型成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.positioningDeviceType.name = null
        this.positioningDeviceType.manufacturername = null
        this.positioningDeviceType.parameter = null
        this.positioningDeviceType.manufacturer = null
        this.positioningDeviceType.isfree = null
        this.positioningDeviceType.remark = null
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.name,
        manufacturername: this.manufacturername
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
